import clsx from 'clsx';

import type * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';

import { INTEGRATIONS_CATEGORY_PROPS } from '../../../Components';
import { useNavigation } from '../../../navigation';
import { useIntegrationsScreen } from '../hooks';

/** Picker for user to select a category to filter an integrations list. */
export function IntegrationCategoryPicker(props: { className?: string }) {
    const { navigate } = useNavigation();
    const { category } = useIntegrationsScreen();

    return (
        <Picker<api.IntegrationCategory | undefined>
            size="large"
            value={category}
            placeholder="All Categories"
            items={integrationCategoryItems}
            onValueChange={(selectedCategory) => {
                navigate({ current: { category: selectedCategory } });
            }}
            className={clsx('min-w-36 shrink-0', props.className)}
        />
    );
}

const integrationCategoryItems: PickerItemData<api.IntegrationCategory | undefined>[] = [
    {
        value: undefined,
        label: 'All categories',
    },
    ...Object.values(INTEGRATIONS_CATEGORY_PROPS).map(({ value, label }) => ({
        value,
        label,
    })),
];
